import { getCoreRowModel, getPaginationRowModel, useReactTable } from '@tanstack/react-table'
import React, {useEffect, useState} from 'react'
import { Table } from 'src/components/era-package'
import { authListCols } from '../../shared'
import { Skeleton } from '@mui/material'
import AbiStatementViewApiUrls from "../../../../../apiUrls/AbiStatementViewApiUrls";

const fetchData = (setData = () => { }, setLoading = () => { }, statement) => {
  console.log(statement)
  let isAlive = true
  setLoading(true)

  let apiUrl = AbiStatementViewApiUrls.GET_DAILY_DETAILS
      + `?statementNumber=${statement.statementNumber}`
      + `&isFinalized=${statement.isFinalized}`

  fetch(apiUrl, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('userToken'))
    },
  })
      .then(res => res.json())
      .then(async (result) => {
        if (isAlive && result.status === 200) setData(result.data.statementAuthorizationList)
      }).catch(() => {
    if (isAlive) setData([])
  }).finally(() => {
    if (isAlive) setLoading(false)
  })

  return () => { isAlive = false }
}

export const AuthList = ({ authData, statement, ...props }) => {

  const [data, setData] = useState(authData)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setData(authData);
  }, [authData]);

  const table = useReactTable({
    data, columns: authListCols,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getRowCanExpand: () => true,
    getSubRows: row => row.response,
    initialState: { pagination: { pageSize: 10 } },
  })

  const handleRowExpansion = (row) => {
    const NestedRow = React.lazy(() => import('./ResponseList'));
    return (
      <React.Suspense fallback={<Skeleton />}>
        <NestedRow data={row.originalSubRows} />
      </React.Suspense>
    );
  }

  return <Table table={table}
    rowCount={data.length}
    renderExpandedRow={handleRowExpansion}
    container={{ sx: { py: 1 } }}
    onRefresh={() => fetchData(setData, setLoading, statement)}
    loading={loading}
  />
}